module.exports = __webpack_public_path__ + "static/media/B1B2BB47-7854-4141-93BA-CC61BE31D047.754dc434.JPG";